import { CommonModule } from '@angular/common';
import {
    Component,
    computed,
    inject,
    input,
    InputSignal,
    Signal,
} from '@angular/core';
import { isNil } from 'lodash';
import {
    buttonCtaMap,
    colorMap,
    EquipmentType,
    marketConditionsUpsellDescription,
    marketConditionsUpsellPoints,
    marketConditionsUpsellTitle,
    rateViewUpsellDescription,
    rateViewUpsellPoints,
    rateViewUpsellTitle,
    UpsellButtonCta,
    UpsellPoints,
    UpsellType,
} from '../models';
import { IqTrendlinesUpsellStateService } from '../state';
import { IqTrendlinesFfStateService } from '@dat/iq-trendlines-ff';

@Component({
    selector: 'iq-trendlines-upsell-banner',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './iq-trendlines-upsell-banner.component.html',
    styleUrl: './iq-trendlines-upsell-banner.component.scss',
})
export class IqTrendlinesUpsellBannerComponent {
    id: InputSignal<string> = input();
    type: InputSignal<UpsellType> = input();
    equipmentType: InputSignal<EquipmentType> = input();

    private _state: IqTrendlinesUpsellStateService = inject(
        IqTrendlinesUpsellStateService,
    );
    private _ff: IqTrendlinesFfStateService = inject(
        IqTrendlinesFfStateService,
    );

    upsellEnabled: Signal<boolean> = computed(() => {
        return this._ff.isFlagEnabledSig('trendlines_upsell')();
    });

    upsellTitle: Signal<string> = computed(() => {
        switch (this.type()) {
            case UpsellType.MarketConditions:
                return marketConditionsUpsellTitle;
            case UpsellType.RateView:
                return rateViewUpsellTitle;
            default:
                return '';
        }
    });

    upsellDescription: Signal<string> = computed(() => {
        switch (this.type()) {
            case UpsellType.MarketConditions:
                return marketConditionsUpsellDescription;
            case UpsellType.RateView:
                return rateViewUpsellDescription;
            default:
                return '';
        }
    });

    upsellPoints: Signal<UpsellPoints[]> = computed(() => {
        switch (this.type()) {
            case UpsellType.MarketConditions:
                return marketConditionsUpsellPoints;
            case UpsellType.RateView:
                return rateViewUpsellPoints;
            default:
                return [];
        }
    });

    bannerColor: Signal<string> = computed(() => {
        if (isNil(this.equipmentType())) {
            return '';
        }
        return colorMap[this.equipmentType()];
    });

    buttonCta: Signal<UpsellButtonCta> = computed(() => {
        if (isNil(this.type())) {
            return { title: '', link: '' };
        }
        return buttonCtaMap[this.type()];
    });

    dispatchUpsellEvent() {
        const upsellTypeToEventAppName = {
            [UpsellType.MarketConditions]: 'Market Conditions',
            [UpsellType.RateView]: 'RateView',
        };
        const eventAppName = upsellTypeToEventAppName[this.type()];
        this._state.dipstachUpsellSegmentEvent(eventAppName);
    }

    constructor() {}
}
